import React from 'react';
import { AiOutlineClose } from "react-icons/ai";

const DepositRule = ({ showPopup, togglePopup }) => {
    return (
        <div>
            {showPopup && (
                <div className="deposit-icon-popup">
                    <div className="deposit-popup-content">
                        <div className='bonus-rule'>
                            <div className='deposit-bonus-rule'>
                                Deposit Bonus Rules
                            </div>
                            <AiOutlineClose
                                className="close-icon"
                                onClick={togglePopup}
                                style={{ cursor: "pointer" }}
                            />
                        </div>
                        <div className='deposit-rule' >
                            <div className='bonus-g'>
                                <div className='bonus-gift'>
                                    <div className='bonus-gift-content'>
                                        <div className='bonus-gift-h1'>1st Deposit Bonus</div>
                                        <div className='bonus-gift-h2'>180%</div>
                                        <div className='bonus-gift-h3'>Min. deposit: ₹854.27</div>
                                    </div>
                                    <div className='bonus-gift-img'>
                                        <img src='assets/bcimages/bonus/gift1.webp' />
                                    </div>
                                </div>
                                <div className='bonus-gift'>
                                    <div className='bonus-gift-content'>
                                        <div className='bonus-gift-h1'>2nd Deposit Bonus</div>
                                        <div className='bonus-gift-h2'>240%</div>
                                        <div className='bonus-gift-h3'>Min. deposit: ₹4,272.05</div>
                                    </div>
                                    <div className='bonus-gift-img'>
                                        <img src='assets/bcimages/bonus/gift2.webp' />
                                    </div>
                                </div>
                                <div className='bonus-gift'>
                                    <div className='bonus-gift-content'>
                                        <div className='bonus-gift-h1'>3rd Deposit Bonus</div>
                                        <div className='bonus-gift-h2'>300%</div>
                                        <div className='bonus-gift-h3'>Min. deposit: ₹8,544.11</div>
                                    </div>
                                    <div className='bonus-gift-img'>
                                        <img src='assets/bcimages/bonus/gift3.webp' />
                                    </div>
                                </div>
                                <div className='bonus-gift'>
                                    <div className='bonus-gift-content'>
                                        <div className='bonus-gift-h1'>4th Deposit Bonus</div>
                                        <div className='bonus-gift-h2'>360%</div>
                                        <div className='bonus-gift-h3'>Min. deposit: ₹17,088.22</div>
                                    </div>
                                    <div className='bonus-gift-img'>
                                        <img src='assets/bcimages/bonus/gift4.webp' />
                                    </div>
                                </div>
                            </div>
                            <div className='bonus-rule-content'>
                                <div className='rule-p'>
                                BCGAME.LU offers an outstanding bonus for 4 consecutive deposits. Each deposit earns you a higher bonus percentage and a higher maximum limit than the last. Enjoy increasing rewards with every deposit, supporting any currency of your choice. Take advantage of this opportunity to maximize your benefits with BCGAME.LU’s generous bonuses!




                                </div>
                                
                               
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DepositRule;
